import React, { useState } from "react";
import { Card, Row, Col } from "react-bootstrap";
import { FaFilePdf, FaLink } from "react-icons/fa";
import "./style.css";
import PageTitle from "../../layouts/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import {
  confirmedGetProjectByIdAction,
  getProjectById,
  updateProjectStatus,
} from "../../../store/actions/ProjectActions";
import {
  formatDateProject,
  getAgeFromDob,
  getStatusSelectStyles,
} from "../../../utils/functions/date";
import { projectStatusOptions } from "../../../utils/constant";
import Swal from "sweetalert2";
import FormHandler from "../../components/Forms/FormHandler";
import UpdateBanner from "./forms/UpdateBanner";
import {
  artistValidationSchema,
  projectBannerValidationSchema,
  projectValidationSchema,
} from "../../../utils/validationSchemas/MasterDataSchema";
import { getImageUrl } from "../Artist/ArtistAvatar";
import FormModal from "../../components/Modal/FormModal";
import EditProject from "./forms/EditProject";
import { globaltriggerDelete } from "../../components/CustomTable";

function formatGender(gender) {
  if (!gender) return "-";
  
  // Check if gender is "Prefer Not to Share" (case-insensitive)
  if (gender.toLowerCase() === "prefer not to share") {
    return "Not Sharing";
  }
  
  // Capitalize first letter
  return gender.charAt(0).toUpperCase() + gender.slice(1).toLowerCase();
}

export const ProjectData = ({ project }) => (
  <Row>
    <Col md={6}>
      <div className="py-3 d-flex justify-content-between align-items-center border-bottom-project">
        <span className="fw-semibold">Concept Title</span>
        <p style={{ margin: 0 }}>{project?.conceptTitle}</p>
      </div>
      <div className="py-3 d-flex justify-content-between border-bottom-project align-items-center">
        <span className="fw-semibold">Format / Duration</span>
        <p>{project?.duration}</p>
      </div>
      <div className="py-3 d-flex justify-content-between border-bottom-project align-items-center">
        <span className="fw-semibold">Art Form</span>
        <p>{project?.artForm?.name ?? "-"}</p>
      </div>
      <div className="py-3 d-flex justify-content-between border-bottom-project align-items-center">
        <span className="fw-semibold">Genre</span>
        <p>{project?.genre?.name ?? "-"}</p>
      </div>
      <div className="py-3 d-flex justify-content-between border-bottom-project align-items-center">
        {console.log("svniosenvisev", project)}
        <span className="fw-semibold">Role of Applicant</span>
        <p>
          {
            project?.ArtistProject?.find((x) =>
              x?.artist == project?.artist?._id
                ? project?.artist?._id
                : project?.artist
            )?.role
          }
        </p>
      </div>
      <div className="py-3 d-flex justify-content-between border-bottom-project align-items-center">
        <span className="fw-semibold">Previously Showcased?</span>
        <p>{project?.previouslyShowcased ? "Yes" : "No"}</p>
      </div>
      <div className="py-3 border-bottom-project">
        <span className="fw-semibold">Concept Description</span>
        <p className="text-muted small mt-2">{project?.conceptNote}</p>
        {/* <a href="#" className="text-primary small mt-2">
                Read More...
              </a> */}
      </div>
    </Col>

    {/* Supporting Material */}
    <Col md={6}>
      <h6 className="fw-semibold mb-3" style={{ fontSize: "18px" }}>
        Supporting Material
      </h6>
      <a
        href={getImageUrl(project?.supportingMaterialPdf)}
        target="_blank"
        rel="noreferrer"
        className="text-decoration-none"
      >
        <div
          className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
          style={{
            minHeight: "50px",
          }}
        >
          <span>
            <FaFilePdf className="text-primary me-2" />
            {project?.supportingMaterialPdf
              ? "Concept Material"
              : "Add Supporting Material"}
          </span>
          <span>
            {/* <FaSync className="me-3" /> */}
            {/* <FaTrashAlt className="text-primary" /> */}
          </span>
        </div>
      </a>

      {project?.artist?.portfolioPdf ? (
        <a
          href={getImageUrl(project?.artist?.portfolioPdf)}
          target="_blank"
          rel="noreferrer"
          className="text-decoration-none"
        >
          <div
            className="d-flex align-items-center justify-content-between border rounded p-2 mb-3"
            style={{
              minHeight: "50px",
            }}
          >
            <span>
              <FaFilePdf className="text-primary me-2" />
              {/* Personal Portfolio */}
              {project?.artist?.portfolioPdf
                ? "Personal Portfolio"
                : "Add Supporting Material"}
            </span>
            <span>
              {/* <FaSync className="me-3" />
                <FaTrashAlt className="text-primary" /> */}
            </span>
          </div>
        </a>
      ) : null}
      {project?.artist?.referenceLinks?.length > 0 ? (
        <>
          <h6 className="fw-semibold my-4" style={{ fontSize: "18px" }}>
            Additional References
          </h6>
          {project?.artist?.referenceLinks?.map((ele, index) => (
            <a
              href={ele}
              target="_blank"
              rel="noreferrer"
              className="text-decoration-none"
            >
              <div
                className="d-flex align-items-center justify-content-between border rounded p-2 mb-2"
                style={{
                  minHeight: "50px",
                }}
              >
                <span>
                  <FaLink className="text-blue me-2" />
                  Link to Reference Work - {index + 1}
                </span>
              </div>
            </a>
          ))}
        </>
      ) : null}
    </Col>
  </Row>
);

export const ArtistDetails = ({ projectDetails }) => {
  return [
    {
      label: "Name",
      value: `${projectDetails?.artist?.firstName} ${projectDetails?.artist?.lastName}`,
      className: "text-primary",
    },
    {
      label: "Age",
      value: getAgeFromDob(projectDetails?.artist?.dob),
    },
    {
      label: "Date of Birth",
      value: formatDateProject(projectDetails?.artist?.dob),
    },
    {
      label: "Email Address",
      value: projectDetails?.artist?.email,
    },
    {
      label: "Mobile Number",
      value: `${projectDetails?.artist?.countryCode} ${projectDetails?.artist?.mobileNumber}`,
    },
    { label: "City", value: projectDetails?.artist?.city?.name },
    {
      label: "Gender",
      value: formatGender(projectDetails?.artist?.gender),
    },
    {
      label: "Instagram",
      value: `${
        projectDetails?.artist?.instagramProfile
          ? "@" + projectDetails?.artist?.instagramProfile
          : "-"
      } `,
      className: "text-primary",
    },
  ].map((item, idx) => (
    <div
      key={idx}
      className={` py-3 d-flex justify-content-between border-bottom-project align-items-center ${
        idx !== 7 ? "border-bottom" : ""
      }`}
    >
      <span className="fw-semibold" style={{ fontSize: "16px" }}>
        {item.label}
      </span>
      <p
        className={`text-end ${item.className || ""}`}
        style={{ fontSize: "16px" }}
      >
        {item.value}
      </p>
    </div>
  ));
};

export const ProjectDetailsCard = ({ project }) => {
  return (
    <Card className="shadow-sm mb-4 border-0 project-details-card">
      <Card.Body>
        <h5 className="mb-0 text-primary fw-semibold mb-4 project-title">
          Project Proposal Details
        </h5>

        {/* Details */}
        <ProjectData project={project} />
      </Card.Body>
    </Card>
  );
};

export const ParticipationDetails = ({ projectDetails }) => {
  return [
    {
      label: "Previous Participation",
      value: projectDetails?.artist?.previousParticipation ? "Yes" : "No",
    },
    {
      label: "Year of Participation",
      value: projectDetails?.artist?.yearOfParticipation || "-",
    },
    {
      label: "Role",
      value:
        projectDetails?.ArtistProject?.filter(
          (x) => x.artist == projectDetails?.artist?._id
        )[0]?.role || "-",
    },
    {
      label: "Awards Received",
      value: projectDetails?.artist?.awardsReceived || "-",
    },
  ].map((item, idx) => (
    <div key={idx} className={`row py-3 ${idx !== 3 ? "border-bottom" : ""}`}>
      <div className="col-6 fw-semibold" style={{ fontSize: "16px" }}>
        {item.label}
      </div>
      <div
        className={`col-6 text-end ${item.className || ""}`}
        style={{ fontSize: "16px" }}
      >
        {item.value}
      </div>
    </div>
  ));
};

export const ProjectDetailsHeader = ({
  projectDetails,
  handleStatusChange,
  refetchData,
}) => {
  const [showModal, setShowModal] = useState(false);
  const closeModal = () => {
    refetchData();
    setShowModal(false);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const deleteProject = () => {
    globaltriggerDelete({
      endPoint: `projects/${projectDetails._id}`,
      dispatch,
      callback: () => navigate(`/projects`),
    });
  };
  const modalConfig = {
    initialValues: {
      _id: projectDetails?._id,
      conceptTitle: projectDetails?.conceptTitle,
      duration: projectDetails?.duration,
      role: projectDetails?.role,
      conceptNote: projectDetails?.conceptNote,
      artForm: projectDetails?.artForm?._id ?? "",
      genre: projectDetails?.genre?._id ?? "",
      previouslyShowcased: projectDetails?.previouslyShowcased,
      supportingMaterialPdf: projectDetails?.supportingMaterialPdf,
    },
    validationSchema: projectValidationSchema,
    apiUrl: "projects/update-details/",
    FormComponent: EditProject,
    addTitle: "Add Project",
    updateTitle: "Update Project",
    extraProps: {},
    closeModal: closeModal,
    showModal,
    setShowModal,
  };
  return (
    <div
      className="p-3 my-2 d-flex mb-4 px-4"
      style={{
        background: "#FFF",
      }}
    >
      <div className="main-title d-flex align-items-center justify-content-between w-100">
        {/* Avatar */}
        <div className="d-flex align-items-center gap-2 w-100">
          <div
            className="rounded-circle border d-flex align-items-center justify-content-center me-3"
            style={{ width: "50px", height: "50px" }}
          >
            {projectDetails?.squareImage ? (
              <div
                className="rounded-circle border d-flex align-items-center justify-content-center"
                style={{ width: "40px", height: "40px" }}
              >
                <img
                  src={getImageUrl(projectDetails?.squareImage)}
                  style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                />
              </div>
            ) : (
              <span className="text-muted">○</span>
            )}
          </div>
          <div>
            <h1>{projectDetails?.conceptTitle}</h1>
            <p>
              By {projectDetails?.artist?.firstName}{" "}
              {projectDetails?.artist?.lastName} |{" "}
              {getAgeFromDob(projectDetails?.artist?.dob)} |{" "}
              {formatGender(projectDetails?.artist?.gender)} |{" "}
              {projectDetails?.artist?.city?.name}
            </p>
          </div>
        </div>

        <div className="align-items-center d-flex gap-2 justify-content-end w-100">
          {/* Right Side - Tags & Buttons */}
          <div className="d-flex align-items-center">
            {/* Tag */}
            <span className="artFrom-badge">
              {projectDetails?.artForm?.name ?? "-"}
              {projectDetails?.artForm?.name && projectDetails?.genre?.name
                ? ` | ${projectDetails?.genre?.name}`
                : "-"}
            </span>
            {projectDetails?.artist?.projects?.length > 1 ? (
              <span className="artist-application-badge">
                {projectDetails?.artist?.projects?.length == 2
                  ? "1 More Application"
                  : `${
                      projectDetails?.artist?.projects?.length - 1
                    } More Applications`}
              </span>
            ) : null}
            <select
              className="form-select"
              value={projectDetails?.status || "New Project"}
              onChange={handleStatusChange}
              style={{
                width: "180px",
                ...getStatusSelectStyles(
                  projectDetails?.status || "New Project"
                ),
              }}
            >
              {projectStatusOptions.map((status, idx) => (
                <option key={idx} value={status}>
                  {status}
                </option>
              ))}
            </select>
          </div>
          <span className="fs-1 fw-light">|</span>
          <div className="">
            <button
              className="btn btn-secondary"
              onClick={() => setShowModal(true)}
            >
              Edit
            </button>
          </div>
          <div className="">
            <button className="btn btn-secondary" onClick={deleteProject}>
              Delete
            </button>
          </div>
        </div>
      </div>
      {showModal ? (
        <FormModal
          modalConfig={{
            ...modalConfig,
          }}
        />
      ) : null}
    </div>
  );
};

// export const ProjectBanner = ({ projectDetails, callBack }) => {
//   return (
//     <UpdateBanner projectDetails={projectDetails} callBack={callBack} />
//   );
// };

const ProjectDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { projectDetails, isLoading } = useSelector((state) => state.projects);
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      dispatch(confirmedGetProjectByIdAction({}));
    };
  }, []);

  const fetchProjectDetails = () => {
    if (id) {
      dispatch(getProjectById(id));
    }
  };
  useEffect(() => {
    fetchProjectDetails(id);
  }, [id]);

  const handleStatusChange = (e) => {
    const newStatus = e.target.value;
    if (id && newStatus) {
      if (projectDetails.status == "Showcase" && newStatus != "Showcase") {
        Swal.fire({
          title: "Are you change the status ?",
          text: "All the Schedules will be deleted if you change the status from Showcase!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#BE282D",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Yes, Change it!",
        }).then((result) => {
          if (result.isConfirmed) {
            dispatch(updateProjectStatus(id, newStatus));
            navigate(`/projects/${id}`);
            Swal.fire(
              "Updated!",
              "Your project status has been updated.",
              "success"
            );
          }
        });
      } else {
        dispatch(updateProjectStatus(id, newStatus));
      }
    }

    if (newStatus === "Showcase") {
      navigate(`/projects/${id}/showcase`);
    }
  };

  if (isLoading && !projectDetails) return <p>Loading project...</p>;
  if (!projectDetails) return <p>No project details found.</p>;

  return (
    <div>
      <PageTitle
        activeMenu="Projects"
        motherMenu="Form"
        to="/projects"
        pageContent="Project Details"
      />
      <div className="container-mxw">
        {projectDetails ? (
          <ProjectDetailsHeader
            projectDetails={projectDetails}
            refetchData={fetchProjectDetails}
            handleStatusChange={handleStatusChange}
          />
        ) : null}
        <ProjectDetailsCard project={projectDetails} />

        <div className="container-fuild d-flex gap-4">
          {/* LEFT SIDE - About Lead Artist */}
          <div className="p-0 w-100">
            <div className="card">
              <div className="card-header bg-white border-0 pb-0">
                <h5 className="mb-0 text-primary fw-semibold project-title">
                  About Lead Artist
                </h5>
              </div>
              <div className="card-body">
                <ArtistDetails projectDetails={projectDetails} />
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="w-100 d-flex flex-column gap-3">
            {/* Card 1: Participation */}
            <div className="card mb-0">
              <div className="card-body">
                <ParticipationDetails projectDetails={projectDetails} />
              </div>
            </div>

            {/* Card 2: Artist */}
            <div className="card mb-0">
              <div className="card-header bg-white border-0 pb-1">
                <h5 className="mb-0 text-primary fw-semibold project-title">
                  Artist
                </h5>
              </div>
              <div className="card-body pt-0 text-muted small">
                Artists can be added once the project is shortlisted
              </div>
            </div>

            {/* Card 3: Shows */}
            <div className="card">
              <div className="card-header bg-white border-0 pb-1">
                <h5 className="mb-0 text-primary fw-semibold project-title">
                  Shows
                </h5>
              </div>
              <div className="card-body pt-0 text-muted small">
                Shows can be added once the project is shortlisted
              </div>
            </div>
          </div>
        </div>
        <div className="col-6">
          <UpdateBanner
            projectDetails={projectDetails}
            callBack={fetchProjectDetails}
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
